module.exports = __webpack_public_path__ + "static/media/Date.d9efdd98.svg";